import {
  useInfiniteQuery,
  useQuery
} from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import axios from 'axios'
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  GetHlsPlaylist404,
  GetHlsPlaylistByPath404,
  GetHlsSegment404,
  GetHlsSegmentByPath404,
  GetStreamingInfo200,
  GetStreamingInfo404,
  GetStreamingInfoByPath200,
  GetStreamingInfoByPath404
} from './types'


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;



/**
 * HLS 비디오 스트리밍을 위한 정보를 조회합니다.
 * @summary 비디오 스트리밍 정보 조회
 */
export const getStreamingInfo = (
    id: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetStreamingInfo200>> => {
    
    return axios.get(
      `https://api.ugot.uk/api/media/stream/${id}`,options
    );
  }


export const getGetStreamingInfoQueryKey = (id: number,) => {
    return [`https://api.ugot.uk/api/media/stream/${id}`] as const;
    }

    
export const getGetStreamingInfoInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getStreamingInfo>>, TError = AxiosError<GetStreamingInfo404>>(id: number, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getStreamingInfo>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStreamingInfoQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStreamingInfo>>> = ({ signal }) => getStreamingInfo(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getStreamingInfo>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStreamingInfoInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getStreamingInfo>>>
export type GetStreamingInfoInfiniteQueryError = AxiosError<GetStreamingInfo404>

/**
 * @summary 비디오 스트리밍 정보 조회
 */
export const useGetStreamingInfoInfinite = <TData = Awaited<ReturnType<typeof getStreamingInfo>>, TError = AxiosError<GetStreamingInfo404>>(
 id: number, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getStreamingInfo>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetStreamingInfoInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetStreamingInfoQueryOptions = <TData = Awaited<ReturnType<typeof getStreamingInfo>>, TError = AxiosError<GetStreamingInfo404>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStreamingInfo>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStreamingInfoQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStreamingInfo>>> = ({ signal }) => getStreamingInfo(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStreamingInfo>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStreamingInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getStreamingInfo>>>
export type GetStreamingInfoQueryError = AxiosError<GetStreamingInfo404>

/**
 * @summary 비디오 스트리밍 정보 조회
 */
export const useGetStreamingInfo = <TData = Awaited<ReturnType<typeof getStreamingInfo>>, TError = AxiosError<GetStreamingInfo404>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStreamingInfo>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetStreamingInfoQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * HLS 비디오의 재생 목록(m3u8)을 조회합니다.
 * @summary HLS 재생 목록 조회
 */
export const getHlsPlaylist = (
    id: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    
    return axios.get(
      `https://api.ugot.uk/api/media/stream/${id}/playlist.m3u8`,options
    );
  }


export const getGetHlsPlaylistQueryKey = (id: number,) => {
    return [`https://api.ugot.uk/api/media/stream/${id}/playlist.m3u8`] as const;
    }

    
export const getGetHlsPlaylistInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getHlsPlaylist>>, TError = AxiosError<GetHlsPlaylist404>>(id: number, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getHlsPlaylist>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHlsPlaylistQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHlsPlaylist>>> = ({ signal }) => getHlsPlaylist(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getHlsPlaylist>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHlsPlaylistInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getHlsPlaylist>>>
export type GetHlsPlaylistInfiniteQueryError = AxiosError<GetHlsPlaylist404>

/**
 * @summary HLS 재생 목록 조회
 */
export const useGetHlsPlaylistInfinite = <TData = Awaited<ReturnType<typeof getHlsPlaylist>>, TError = AxiosError<GetHlsPlaylist404>>(
 id: number, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getHlsPlaylist>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetHlsPlaylistInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetHlsPlaylistQueryOptions = <TData = Awaited<ReturnType<typeof getHlsPlaylist>>, TError = AxiosError<GetHlsPlaylist404>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHlsPlaylist>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHlsPlaylistQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHlsPlaylist>>> = ({ signal }) => getHlsPlaylist(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHlsPlaylist>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHlsPlaylistQueryResult = NonNullable<Awaited<ReturnType<typeof getHlsPlaylist>>>
export type GetHlsPlaylistQueryError = AxiosError<GetHlsPlaylist404>

/**
 * @summary HLS 재생 목록 조회
 */
export const useGetHlsPlaylist = <TData = Awaited<ReturnType<typeof getHlsPlaylist>>, TError = AxiosError<GetHlsPlaylist404>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHlsPlaylist>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetHlsPlaylistQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * HLS 비디오의 특정 세그먼트(.ts 파일)를 조회합니다.
 * @summary HLS 세그먼트 조회
 */
export const getHlsSegment = (
    id: number,
    segmentId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Blob>> => {
    
    return axios.get(
      `https://api.ugot.uk/api/media/stream/${id}/segment/${segmentId}`,{
        responseType: 'blob',
    ...options,}
    );
  }


export const getGetHlsSegmentQueryKey = (id: number,
    segmentId: string,) => {
    return [`https://api.ugot.uk/api/media/stream/${id}/segment/${segmentId}`] as const;
    }

    
export const getGetHlsSegmentInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getHlsSegment>>, TError = AxiosError<GetHlsSegment404>>(id: number,
    segmentId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getHlsSegment>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHlsSegmentQueryKey(id,segmentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHlsSegment>>> = ({ signal }) => getHlsSegment(id,segmentId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id && segmentId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getHlsSegment>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHlsSegmentInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getHlsSegment>>>
export type GetHlsSegmentInfiniteQueryError = AxiosError<GetHlsSegment404>

/**
 * @summary HLS 세그먼트 조회
 */
export const useGetHlsSegmentInfinite = <TData = Awaited<ReturnType<typeof getHlsSegment>>, TError = AxiosError<GetHlsSegment404>>(
 id: number,
    segmentId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getHlsSegment>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetHlsSegmentInfiniteQueryOptions(id,segmentId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetHlsSegmentQueryOptions = <TData = Awaited<ReturnType<typeof getHlsSegment>>, TError = AxiosError<GetHlsSegment404>>(id: number,
    segmentId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHlsSegment>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHlsSegmentQueryKey(id,segmentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHlsSegment>>> = ({ signal }) => getHlsSegment(id,segmentId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id && segmentId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHlsSegment>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHlsSegmentQueryResult = NonNullable<Awaited<ReturnType<typeof getHlsSegment>>>
export type GetHlsSegmentQueryError = AxiosError<GetHlsSegment404>

/**
 * @summary HLS 세그먼트 조회
 */
export const useGetHlsSegment = <TData = Awaited<ReturnType<typeof getHlsSegment>>, TError = AxiosError<GetHlsSegment404>>(
 id: number,
    segmentId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHlsSegment>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetHlsSegmentQueryOptions(id,segmentId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 파일 경로로 HLS 비디오 스트리밍을 위한 정보를 조회합니다.
 * @summary 경로로 비디오 스트리밍 정보 조회
 */
export const getStreamingInfoByPath = (
    path: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetStreamingInfoByPath200>> => {
    
    return axios.get(
      `https://api.ugot.uk/api/media/stream/path/${path}`,options
    );
  }


export const getGetStreamingInfoByPathQueryKey = (path: string,) => {
    return [`https://api.ugot.uk/api/media/stream/path/${path}`] as const;
    }

    
export const getGetStreamingInfoByPathInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getStreamingInfoByPath>>, TError = AxiosError<GetStreamingInfoByPath404>>(path: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getStreamingInfoByPath>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStreamingInfoByPathQueryKey(path);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStreamingInfoByPath>>> = ({ signal }) => getStreamingInfoByPath(path, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(path),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getStreamingInfoByPath>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStreamingInfoByPathInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getStreamingInfoByPath>>>
export type GetStreamingInfoByPathInfiniteQueryError = AxiosError<GetStreamingInfoByPath404>

/**
 * @summary 경로로 비디오 스트리밍 정보 조회
 */
export const useGetStreamingInfoByPathInfinite = <TData = Awaited<ReturnType<typeof getStreamingInfoByPath>>, TError = AxiosError<GetStreamingInfoByPath404>>(
 path: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getStreamingInfoByPath>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetStreamingInfoByPathInfiniteQueryOptions(path,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetStreamingInfoByPathQueryOptions = <TData = Awaited<ReturnType<typeof getStreamingInfoByPath>>, TError = AxiosError<GetStreamingInfoByPath404>>(path: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStreamingInfoByPath>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStreamingInfoByPathQueryKey(path);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStreamingInfoByPath>>> = ({ signal }) => getStreamingInfoByPath(path, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(path),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStreamingInfoByPath>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStreamingInfoByPathQueryResult = NonNullable<Awaited<ReturnType<typeof getStreamingInfoByPath>>>
export type GetStreamingInfoByPathQueryError = AxiosError<GetStreamingInfoByPath404>

/**
 * @summary 경로로 비디오 스트리밍 정보 조회
 */
export const useGetStreamingInfoByPath = <TData = Awaited<ReturnType<typeof getStreamingInfoByPath>>, TError = AxiosError<GetStreamingInfoByPath404>>(
 path: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStreamingInfoByPath>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetStreamingInfoByPathQueryOptions(path,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 파일 경로로 HLS 비디오의 재생 목록(m3u8)을 조회합니다.
 * @summary 경로로 HLS 재생 목록 조회
 */
export const getHlsPlaylistByPath = (
    path: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    
    return axios.get(
      `https://api.ugot.uk/api/media/stream/path/${path}/playlist.m3u8`,options
    );
  }


export const getGetHlsPlaylistByPathQueryKey = (path: string,) => {
    return [`https://api.ugot.uk/api/media/stream/path/${path}/playlist.m3u8`] as const;
    }

    
export const getGetHlsPlaylistByPathInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getHlsPlaylistByPath>>, TError = AxiosError<GetHlsPlaylistByPath404>>(path: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getHlsPlaylistByPath>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHlsPlaylistByPathQueryKey(path);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHlsPlaylistByPath>>> = ({ signal }) => getHlsPlaylistByPath(path, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(path),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getHlsPlaylistByPath>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHlsPlaylistByPathInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getHlsPlaylistByPath>>>
export type GetHlsPlaylistByPathInfiniteQueryError = AxiosError<GetHlsPlaylistByPath404>

/**
 * @summary 경로로 HLS 재생 목록 조회
 */
export const useGetHlsPlaylistByPathInfinite = <TData = Awaited<ReturnType<typeof getHlsPlaylistByPath>>, TError = AxiosError<GetHlsPlaylistByPath404>>(
 path: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getHlsPlaylistByPath>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetHlsPlaylistByPathInfiniteQueryOptions(path,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetHlsPlaylistByPathQueryOptions = <TData = Awaited<ReturnType<typeof getHlsPlaylistByPath>>, TError = AxiosError<GetHlsPlaylistByPath404>>(path: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHlsPlaylistByPath>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHlsPlaylistByPathQueryKey(path);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHlsPlaylistByPath>>> = ({ signal }) => getHlsPlaylistByPath(path, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(path),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHlsPlaylistByPath>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHlsPlaylistByPathQueryResult = NonNullable<Awaited<ReturnType<typeof getHlsPlaylistByPath>>>
export type GetHlsPlaylistByPathQueryError = AxiosError<GetHlsPlaylistByPath404>

/**
 * @summary 경로로 HLS 재생 목록 조회
 */
export const useGetHlsPlaylistByPath = <TData = Awaited<ReturnType<typeof getHlsPlaylistByPath>>, TError = AxiosError<GetHlsPlaylistByPath404>>(
 path: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHlsPlaylistByPath>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetHlsPlaylistByPathQueryOptions(path,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 파일 경로로 HLS 비디오의 특정 세그먼트(.ts 파일)를 조회합니다.
 * @summary 경로로 HLS 세그먼트 조회
 */
export const getHlsSegmentByPath = (
    path: string,
    segmentId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Blob>> => {
    
    return axios.get(
      `https://api.ugot.uk/api/media/stream/path/${path}/segment/${segmentId}`,{
        responseType: 'blob',
    ...options,}
    );
  }


export const getGetHlsSegmentByPathQueryKey = (path: string,
    segmentId: string,) => {
    return [`https://api.ugot.uk/api/media/stream/path/${path}/segment/${segmentId}`] as const;
    }

    
export const getGetHlsSegmentByPathInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getHlsSegmentByPath>>, TError = AxiosError<GetHlsSegmentByPath404>>(path: string,
    segmentId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getHlsSegmentByPath>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHlsSegmentByPathQueryKey(path,segmentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHlsSegmentByPath>>> = ({ signal }) => getHlsSegmentByPath(path,segmentId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(path && segmentId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getHlsSegmentByPath>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHlsSegmentByPathInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getHlsSegmentByPath>>>
export type GetHlsSegmentByPathInfiniteQueryError = AxiosError<GetHlsSegmentByPath404>

/**
 * @summary 경로로 HLS 세그먼트 조회
 */
export const useGetHlsSegmentByPathInfinite = <TData = Awaited<ReturnType<typeof getHlsSegmentByPath>>, TError = AxiosError<GetHlsSegmentByPath404>>(
 path: string,
    segmentId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getHlsSegmentByPath>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetHlsSegmentByPathInfiniteQueryOptions(path,segmentId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetHlsSegmentByPathQueryOptions = <TData = Awaited<ReturnType<typeof getHlsSegmentByPath>>, TError = AxiosError<GetHlsSegmentByPath404>>(path: string,
    segmentId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHlsSegmentByPath>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHlsSegmentByPathQueryKey(path,segmentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHlsSegmentByPath>>> = ({ signal }) => getHlsSegmentByPath(path,segmentId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(path && segmentId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHlsSegmentByPath>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHlsSegmentByPathQueryResult = NonNullable<Awaited<ReturnType<typeof getHlsSegmentByPath>>>
export type GetHlsSegmentByPathQueryError = AxiosError<GetHlsSegmentByPath404>

/**
 * @summary 경로로 HLS 세그먼트 조회
 */
export const useGetHlsSegmentByPath = <TData = Awaited<ReturnType<typeof getHlsSegmentByPath>>, TError = AxiosError<GetHlsSegmentByPath404>>(
 path: string,
    segmentId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHlsSegmentByPath>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetHlsSegmentByPathQueryOptions(path,segmentId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



